import { useRef, useState } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type tab = {
    key: number;
    name: string;
    desc: string;
    link: string;
};

export default function Recommend() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [currentIndex, setCurrentIndex] = useState(2);
    const headRef = useRef(null);

    const tabs: tab[] = [
        {
            key: 0,
            name: t('recommend.Media0'),
            desc: t.rich('recommend.Quote0', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.theverge.com/2023/1/5/23536809/ecoflow-whole-home-backup-price-tax-credit-specs',
        },
        {
            key: 1,
            name: t('recommend.Media1'),
            desc: t.rich('recommend.Quote1', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://techcrunch.com/2023/01/05/ecoflow-launches-battery-backup-a-lawnmower-a-portable-a-c-and-a-portable-fridge/amp/',
        },
        {
            key: 2,
            name: t('recommend.Media2'),
            desc: t.rich('recommend.Quote2', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.benzinga.com/general/23/03/31494970/how-to-prepare-your-home-for-power-grid-brownouts-blackouts',
        },
        {
            key: 3,
            name: t('recommend.Media3'),
            desc: t.rich('recommend.Quote3', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://www.makeuseof.com/ecoflow-launches-whole-home-backup-power-solution/',
        },
        {
            key: 4,
            name: t('recommend.Media4'),
            desc: t.rich('recommend.Quote4', {
                p1: (children: any) => <span className="quote">{children}</span>,
                p2: (children: any) => <span className="quote">{children}</span>,
            }),
            link: 'https://phandroid.com/2023/01/05/ecoflows-new-power-station-can-backup-your-entire-home/',
        },
    ];

    const handleChangeTab = (val: number) => {
        setCurrentIndex(val);
        if (locale === 'sa') {
            return;
        }
        if (val === 1) {
            (headRef?.current as any).scrollTo({ left: 0 });
        }
        if (val === 3) {
            (headRef?.current as any).scrollTo({ left: 1000 });
        }
    };

    return (
        <div className={`${styles.Recommend} Recommend`}>
            <div className="tab-head">
                <div className="title">{t('recommend.title')}</div>
                <div className="tab-head-in" ref={headRef}>
                    {tabs.map((item) => (
                        <div key={item.key} className={`tab-head-item ${currentIndex === item.key ? 'active' : ''}`} onClick={() => handleChangeTab(item.key)}>
                            {item.name}
                        </div>
                    ))}
                </div>
                <div className="line"></div>
            </div>
            <div className="tab-cont">
                {tabs.map((item) => (
                    <div key={item.key} className={`tab-cont-item ${currentIndex === item.key ? 'active' : ''}`} onClick={() => window.open(item.link)}>
                        {item.desc}
                    </div>
                ))}
            </div>
        </div>
    );
}
